function initCountdown(countdown: HTMLElement) {
  let timer;
  const dataEnd = countdown.getAttribute('data-end-date');
  const endTimestamp = new Date(dataEnd).getTime();

  if (Number.isNaN(endTimestamp)) {
    return;
  }

  const dateDaysContainer = countdown.querySelector('.js-countdown-days');
  const dateHoursContainer = countdown.querySelector('.js-countdown-hours');
  const dateMinutesContainer = countdown.querySelector('.js-countdown-minutes');
  const dateSecondsContainer = countdown.querySelector('.js-countdown-seconds');

  const dateDays = dateDaysContainer.querySelector('.js-countdown-value');
  const dateHours = dateHoursContainer.querySelector('.js-countdown-value');
  const dateMinutes = dateMinutesContainer.querySelector('.js-countdown-value');
  const dateSeconds = dateSecondsContainer.querySelector('.js-countdown-value');

  function calculate() {
    const startTimestamp = new Date().getTime();
    let timeRemaining = (endTimestamp - startTimestamp) / 1000;

    if (timeRemaining >= 0) {
      const days = parseInt(`${timeRemaining / 86400}`, 10);
      timeRemaining %= 86400;

      const hours = parseInt(`${timeRemaining / 3600}`, 10);
      timeRemaining %= 3600;

      const minutes = parseInt(`${timeRemaining / 60}`, 10);
      timeRemaining %= 60;

      const seconds = parseInt(`${timeRemaining}`, 10);

      // Makes days & hours singular when there is 1 day remaining
      if (days > 1) {
        dateDaysContainer.classList.add('is-plural');
      } else if (days === 1) {
        dateDaysContainer.classList.remove('is-plural');
      } else {
        dateDaysContainer.classList.add('hidden');
      }
      if (hours > 1) {
        dateHoursContainer.classList.add('is-plural');
      } else if (hours === 1) {
        dateHoursContainer.classList.remove('is-plural');
      } else {
        dateHoursContainer.classList.add('hidden');
      }

      // Renders the correct numbers
      dateDays.innerHTML = `0${days}`.slice(-2);
      dateHours.innerHTML = `0${hours}`.slice(-2);
      dateMinutes.innerHTML = `0${minutes}`.slice(-2);
      dateSeconds.innerHTML = `0${seconds}`.slice(-2);

      countdown.classList.remove('is-loading', 'hidden');
    } else {
      countdown.classList.add('hidden');
      clearInterval(timer);
    }
  }

  timer = setInterval(calculate, 1000);
  calculate();
}

const countdownArray: Array<HTMLElement> = Array.from(
  document.querySelectorAll('.js-content-countdown'),
);

countdownArray.forEach(initCountdown);
